import { IRouterController } from "./connector/__types__/UIViewController";
import { RouterController } from "./connector/UIViewController";
import RouterUser from "./RouterUser/RouterUser";
import RouterGuest from "./RouterGuest/RouterGuest";
import { useTrackRouteChanges } from "./hooks/useTrackRouteChanges";
import withControllers from "@view/root/__proto__/withController";
import { useControllers } from "@view/hooks/useControllers";
import { observer } from "mobx-react";

const RootRouter = observer(() => {
  const { UIViewController } = useControllers<{
    UIViewController: IRouterController;
  }>();

  useTrackRouteChanges();

  return (
    <div className="main-wrapper">
      {UIViewController.isUserLoggedIn ? <RouterUser /> : <RouterGuest />}
    </div>
  );
});

export default withControllers(RouterController)(RootRouter);
